import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { List, ListHeading, Spinner } from '@oliasoft-open-source/react-ui-library';
import { routes } from 'routes/routes';
import { generatePath } from 'store/navigation/navigation';
import { selectIsLoadingCompareEstimates } from 'store/entities/compare-estimates/selectors';
import translations from 'src/internationalisation/translation-map.json';

const EstimatesList = ({ estimates, filteredEstimates, isLoading }) => {
  const { t } = useTranslation();
  const { company } = useParams();

  const items =
    estimates?.map((estimate, idx) => ({
      id: estimate.projectId,
      name: estimate.estimateName,
      metadata: filteredEstimates[idx]?.wellName,
      disabled: isLoading,
      onClick: () =>
        window.open(
          generatePath(routes.overview.fullPath, {
            company,
            project: estimate.projectId,
          }),
          '_blank',
        ),
      actions: [
        {
          icon: isLoading ? <Spinner colored tiny /> : null,
        },
      ],
    })) || [];

  return (
    <>
      <ListHeading name={t(translations.estimates)} />
      <List
        list={{
          items,
        }}
        noHeader
      />
    </>
  );
};

const mapStateToProps = (state) => {
  const isLoading = selectIsLoadingCompareEstimates(state);

  return {
    isLoading,
  };
};

const Container = connect(mapStateToProps)(EstimatesList);

export { Container as EstimatesList };
